import { getSlides } from 'chalktalk-react/apis/learn_hub';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { LearnhubData } from '../types';

const handleError = (error: { message: string }) => {
  toast.error(`Something went wrong: ${error.message}`);
  console.error(error.message);
};

const useGetLearnHubSlides = (userId: string, lessonNodeId: string) => {
  const { sectionId } = useParams();

  const key = `${userId}-${sectionId}-${lessonNodeId}`;

  return useQuery<LearnhubData>(
    ['lessonSlides', key],
    () => getSlides(sectionId, userId, lessonNodeId),
    {
      suspense: false,
      onError: handleError,
      enabled: Boolean(userId && lessonNodeId && sectionId),
      refetchOnMount: true,
    },
  );
};

export default useGetLearnHubSlides;
